import { QuestionStatus } from '@exam-management/graphql';
import { Flex, SectionTitle } from '@shared/components';

import { OwnerFormSection } from '../owner-form-section';
import { OwnerView } from '../owner-view';

export interface OwnerSectionProps {
  readonly?: boolean;
  questionStatus?: QuestionStatus;
}

export default function OwnerSection(props: Readonly<OwnerSectionProps>) {
  const { readonly: isReadonly = false, questionStatus = QuestionStatus.Draft } = props;
  const isEditable = questionStatus === QuestionStatus.Draft && !isReadonly;

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <SectionTitle title='Owner' />
      {isEditable ? <OwnerFormSection /> : <OwnerView />}
    </Flex>
  );
}
